// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"876f2915","293":"00229c2b","408":"faf57ad2","453":"b75dfaa1","466":"a658f417"}[chunkId] + ".chunk.js";
};